var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.model)?_c('div',[_c(_vm.currentComponent,_vm._b({tag:"component"},'component',_vm.props,false)),_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }